import React from "react";
import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { AiChatApp } from "./components";

export default class extends Controller {
  private root: ReturnType<typeof createRoot> | null = null;

  connect() {
    const conversationId = parseInt(
      this.element.getAttribute("data-conversation-id") || "0",
    );

    this.root = createRoot(this.element as HTMLElement);
    this.root.render(
      <AiChatApp
        conversationId={conversationId}
      />,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}
